module.exports = __webpack_public_path__ + "static/media/entregachips2.92c64b4e.jpg";